import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMobileScreen,
  faBolt,
  faStar,
  faArrowsRotate,
  faMoon
} from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/mob.css';
import appstoreIcon from '../assets/icons/appstore.png';
import gplayIcon from '../assets/icons/gplay.png';
import mobImage from '../assets/images/mob.jpg';
import mob2Image from '../assets/images/mob2.jpg';

const Mob = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  // Scroll event listener'ı kaldırıldı - artık gerekli değil

  // Intersection Observer ile animasyonları tetikle
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-on-scroll');
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    // Animasyon yapılacak elementleri gözlemle
    const animatedElements = sectionRef.current?.querySelectorAll('.mob-header, .feature-card, .download-content, .mobile-preview');
    animatedElements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: faMobileScreen,
      titleKey: 'mob.feature1.title',
      descriptionKey: 'mob.feature1.description'
    },
    {
      icon: faBolt,
      titleKey: 'mob.feature2.title',
      descriptionKey: 'mob.feature2.description'
    },
    {
      icon: faStar,
      titleKey: 'mob.feature3.title',
      descriptionKey: 'mob.feature3.description'
    },
    {
      icon: faArrowsRotate,
      titleKey: 'mob.feature4.title',
      descriptionKey: 'mob.feature4.description'
    },
    {
      icon: faMoon,
      titleKey: 'mob.feature5.title',
      descriptionKey: 'mob.feature5.description'
    }
  ];

  return (
    <section 
      ref={sectionRef}
      className={`mob-section ${isDarkMode ? 'dark-mode' : ''}`}
    >
      <div className="container">
        <div className="mob-header">
          <h2>{t('mob.title')}</h2>
          <p>{t('mob.subtitle')}</p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={feature.icon} />
              </div>
              <h3>{t(feature.titleKey)}</h3>
              <p>{t(feature.descriptionKey)}</p>
            </div>
          ))}
        </div>
        
        <div className="download-section">
          <div className="download-content">
            <h3>{t('mob.download.title')}</h3>
            <p>{t('mob.download.description')}</p>
            <div className="download-buttons">
              <a 
                href="https://apps.apple.com/sn/app/masgold/id6753982731" 
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn app-store"
              >
                <img src={appstoreIcon} alt={t('common.app_store')} />
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.aifasoft.masgold&hl=tr" 
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn google-play"
              >
                <img src={gplayIcon} alt={t('common.google_play')} />
              </a>
            </div>
          </div>
          
          <div className="mobile-preview">
            <div className="phone-mockup">
              <img src={mobImage} alt={t('mob.preview1')} className="mobile-screenshot" />
            </div>
            <div className="phone-mockup">
              <img src={mob2Image} alt={t('mob.preview2')} className="mobile-screenshot" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mob;
